/*
--------------------
This file contains the nessasary parts of the old NSCVER design needed to continue running the older styled pages
--------------------
*/
// sort plugin that takes value selector rather than standard array comparer
jQuery.fn.orderBy = function (keySelector) {
    return this.sort(function (b, a) {
        a = keySelector.apply(a);
        b = keySelector.apply(b);
        if (a > b)
            return 1;
        if (a < b)
            return -1;
        return 0;
    });
};

// actual code that does stuff
$(".funnelback__ncver-global #facet-3 ul li.category").orderBy(function () { return +$(this).find(".categoryCount").text(); }).appendTo(".funnelback__ncver-global #facet-3 ul.list-unstyled");
$(".funnelback__ncver-data #facet-2 ul li.category").orderBy(function () { return +$(this).find(".categoryCount").text(); }).appendTo(".funnelback__ncver-data #facet-2 ul.list-unstyled");


/* ===============================================================================================================================================
    Share Button
=============================================================================================================================================== */
// Controls hide/show of sharing tools on Desktop
$('.share').click(function () {
    $('#share-options').toggle();
});

/* ===============================================================================================================================================
    Funnelback Results Sort Button
=============================================================================================================================================== */

//   alert('Greater than 767');
$('.fb-sort, #fb-sort-options').mouseover(function () {
    $('#fb-sort-options').show();
});
$('.fb-sort, #fb-sort-options').mouseout(function () {
    $('#fb-sort-options').hide();
});


$(window).on('load', function () {
    if (GetURLParameter('sort') === '') {
        $('#search-advanced li.relevance').addClass('active');
    }
    if (GetURLParameter('sort') === 'dmetaM') {
        $('#search-advanced li.newest-first').addClass('active');
    }
    if (GetURLParameter('sort') === 'metaM') {
        $('#search-advanced li.oldest-first').addClass('active');
    }
    if (GetURLParameter('sort') === 'title') {
        $('#search-advanced li.title-az').addClass('active');
    }
    if (GetURLParameter('sort') === 'dtitle') {
        $('#search-advanced li.title-az').addClass('active');
    }
    if (GetURLParameter('sort') === undefined) {
        //Global search is relevance default
        if($('.funnelback__ncver-global').length > 0){
            $('#search-advanced li.relevance').addClass('active');
        }else{
            //All others are newest first
            $('#search-advanced li.newest-first').addClass('active');
        }        
    }
});
//function chec what contain param in href 
function GetURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) {
            return sParameterName[1];
        }
    }
}


$(".relevance").click(function () { // when .newest-first is clicked, run function
    $("#sort").val(''); // set value of #sort to date (Newest First) value
    $('.fb-sort-btn').click(); // submit advanced search
});

$(".newest-first").click(function () { // when .newest-first is clicked, run function
    $("#sort").val('dmetaM'); // set value of #sort to date (Newest First) value
    $('.fb-sort-btn').click(); // submit advanced search
});

$(".oldest-first").click(function () { // when .newest-first is clicked, run function
    $("#sort").val('metaM'); // set value of #sort to adate (Oldest First) value
    $('.fb-sort-btn').click(); // submit advanced search
});

$(".title-az").click(function () { // when .newest-first is clicked, run function
    $("#sort").val('title'); // set value of #sort to title (Title A-Z) value
    $('.fb-sort-btn').click(); // submit advanced search
});
$(".title-za").click(function () { // when .newest-first is clicked, run function
    $("#sort").val('dtitle'); // set value of #sort to dtitle (Title Z-A) value
    $('.fb-sort-btn').click(); // submit advanced search
});

/* ===============================================================================================================================================
    TOC Automatic Generation - based on h2's inside the .page-content wrapper
=============================================================================================================================================== */

$(document).ready(function () {
    var headingNum = 0;

    if ($('.page-content h2').length > 1) {
        $('.page-content h2').each(function () { // run function for each h2 inside the .page-content wrapper
            $(this).before('<span id="h2heading' + headingNum + '" class="waypointTag"></span>'); // for each h2 add a span with a unique id before() the h2
            $('.page-header__list').append('<li class="page-header__list-item "><a href="#h2heading' + headingNum + '" id="heading' + headingNum + '" class="waypointLink h2heading' + headingNum + '__link">' + $(this).html() + '</a></li>');
            headingNum++; // increment headingNum var for each() time the function runs
        }); // close each() function
    }

}); // close document ready function

$('#search-find__by-author h2').each(function () {
    var h2txt = $(this).text();
    $(this).replaceWith('<div class="search-find__by-author-heading"><h3 class="search-find__by-author-title">' + h2txt + '</h3><span class="search-find__by-author-icon"></span></div>');
});

$(document).ready(function () {
    var headingNumber = 0;

    if ($('.find-by-author, .find_by_author_22063 h3').length > 1) {
        $('find-by-author h3,  .find_by_author_22063 h3').each(function () { // run function for each h2 inside the .page-content wrapper
            $(this).before('<span id="h2heading' + headingNumber + '" class="waypointTagFindByAuthor"></span>'); // for each h2 add a span with a unique id before() the h2
            $('.page-header__list').append('<li class="page-header__list-item "><a href="#h2heading' + headingNumber + '" id="heading' + headingNumber + '" class="waypointLinkFindByAuthor h2heading' + headingNumber + '__link">' + $(this).html() + '</a></li>');
            headingNumber++; // increment headingNum var for each() time the function runs
        }); // close each() function
    }

}); // close document ready function

/* ===============================================================================================================================================
    Create Sticky Table of Contents TOC
=============================================================================================================================================== */

$(function stickyToc() {
    var $stickyElement = $('.page-header__listing-container');
    var $multipleItems = $('.page-header__listing-container ul li').length > 1;
    var sticky;
    if ($stickyElement.length && $multipleItems) {
        sticky = new Waypoint.Sticky({
            element: $stickyElement[0],
            wrapper: '<div class="sticky-wrapper waypoint" />'
        });
    }
});
$('#search-find__by-author ul').each(function () {
    $(this).wrap("<div class='search-find__by-author-group' />")
    $(this).contents().unwrap();
});

/* ===============================================================================================================================================
    Waypoint generation code for managing active styles on TOC items NEW JS 
=============================================================================================================================================== */

$(document).ready(function () {

    $('#heading0').addClass('page-header__highlight'); // add class on page load
    var wrapper = $('.page-header__list');

    $('.waypointTag').waypoint({
        handler: function (direction) {
            if (direction === 'down') {
                wrapper.find('.page-header__highlight').removeClass('page-header__highlight');
                $('.' + this.element.id + '__link').addClass('page-header__highlight');
            }
        },
        offset: function () {
            return $('.page-header__listing-container').height() + 100
        }
    });

    $('.waypointTag').waypoint({
        handler: function (direction) {
            if (direction === 'up') {
                wrapper.find('.page-header__highlight').removeClass('page-header__highlight');
                $('.' + this.element.id + '__link').addClass('page-header__highlight');
            }
        },
        offset: function () {
            return $('.page-header__listing-container').height() - 100
        }
    });

    var wayDown = $('.waypointTagFindByAuthor').waypoint({
        handler: function (direction) {
            if (direction === 'down') {
                wrapper.find('.page-header__highlight').removeClass('page-header__highlight');
                $('.' + this.element.id + '__link').addClass('page-header__highlight');
            }
        },
        offset: 120
    });

    var wayUp = $('.waypointTagFindByAuthor').waypoint({
        handler: function (direction) {
            if (direction === 'up') {
                wrapper.find('.page-header__highlight').removeClass('page-header__highlight');
                $('.' + this.element.id + '__link').addClass('page-header__highlight');
            }
        },
        offset: 55
    });

    //scroll down/top when event click on headings <a href="#h2heading0">heading</a>
    $('a.waypointLink').on('click', function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - $('.page-header__listing-container').height()
                }, 600);
                return false;
            }
        }
    });

    //scroll down/top when event click on headings <a href="#h2heading0">heading</a>
    $('a.waypointLinkFindByAuthor').on('click', function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 115
                }, 600);
                return false;
            }
        }
    });
});


$('.search-find__by-author-heading').on('click', function () {
    $(this).next().toggle();
    $(this).toggleClass('search-find__by-author-open');
    //refreash waipoint on each click event 
    Waypoint.refreshAll();
});


/* ===============================================================================================================================================
    Snippet show more/less function
=============================================================================================================================================== */
$('.snippet__description-show-more').click(function () {
    $(this).parent().hide();
    $(this).parent().next().show();
});
$('.snippet__description-show-less').click(function () {
    $(this).parent().hide();
    $(this).parent().prev().show();
});

/* ===============================================================================================================================================
    Our People page accordion function
=============================================================================================================================================== */
$(window).on('load', function () {
    $('.our-people__person-details').each(function () {
        if ($(this).height() > 260) { // if greater than 350px high
            $(this).addClass('our-people__set-max-height'); // set max height
        }
        if ($(this).height() < 260) { // if less than 350px high
            $(this).next().hide(); // hide height toggle button
        }
    });
});


$('.our-people__toggle-height').on('click', function () {
    $(this).prev().toggleClass('our-people__set-max-height');
    $(this).toggleClass('our-people__active');
});

/* ===============================================================================================================================================
    Find by Author / Subject / Type / Characteristics / Measeures reformatted search link lists
=============================================================================================================================================== */
$('#search-find__by-author li').each(function () {
    var txt = $(this).text();
    $(this).replaceWith('<div class="search-find__listing-item"><a href="/search-results?collection=ncver-pubs&sort=dmetaM&meta_a_prox=' + txt + '&f.Author|a=' + txt + '">' + txt + '</a></div>');
});


$('#search-find__by-subject li').each(function () {
    var txt = $(this).text();
    $(this).replaceWith('<div class="search-find__listing-item"><a href="/search-results?collection=ncver-pubs&sort=dmetaM&meta_o_prox=' + txt + '&f.Subjects|o=' + txt + '">' + txt + '</a></div>');
});

$('#search-find__by-subject ul').contents().unwrap();

$('#search-find__by-type li').each(function () {
    var txt = $(this).text();
    $(this).replaceWith('<div class="search-find__listing-item"><a href="/search-results?collection=ncver-pubs&sort=dmetaM&meta_b_prox=' + txt + '&f.Publication+type|b=' + txt + '">' + txt + '</a></div>');
});
$('#search-find__by-type ul').contents().unwrap();

var characterTemp = [];
$('#search-find__characteristics li').each(function () {
    var txt = $(this).text();
    $(this).replaceWith('<div class="search-find__listing-item"><a href="/search-results?collection=ncver-data&sort=dmetaM&meta_q_prox=' + txt + '&f.Characteristic|q=' + txt + '">' + txt + '</a></div>');
});
$('#search-find__characteristics ul').contents().unwrap();

$('#search-find__measures li').each(function () {
    var txt = $(this).text();
    $(this).replaceWith('<div class="search-find__listing-item"><a href="/search-results?collection=ncver-data&sort=dmetaM&meta_r_prox=' + txt + '&f.Measure|r=' + txt + '">' + txt + '</a></div>');
});
$('#search-find__measures ul').contents().unwrap();



/* ===============================================================================================================================================
    Funnelback Facet Customisations
=============================================================================================================================================== */

// remove all items containing '20'
$('.funnelback__ncver-global #facet-1 .list-unstyled li a:contains("20")').parent().parent().hide();
$('.funnelback__ncver-global #facet-1 .list-unstyled li a:contains("19")').parent().parent().hide();
$('.funnelback__ncver-global #facet-3 .list-unstyled li a:contains("Annual")').parent().parent().hide();
$('.funnelback__ncver-global #facet-3 .list-unstyled li a:contains("Quarterly")').parent().parent().hide();
// remove all items containing 'Past'
$('.funnelback__ncver-global #facet-2 .list-unstyled li a:contains("Past")').parent().parent().hide();

// remove all items containing '20 or 19'
$('.funnelback__ncver-publications #facet-0 .list-unstyled li a:contains("20")').parent().parent().hide();
$('.funnelback__ncver-publications #facet-0 .list-unstyled li a:contains("19")').parent().parent().hide();
// remove all items containing 'Past year'
$('.funnelback__ncver-publications #facet-1 .list-unstyled li a:contains("Past")').parent().parent().hide();


// remove all items containing '20'
$('.funnelback__ncver-data #facet-0 .list-unstyled li a:contains("20")').parent().parent().hide();
$('.funnelback__ncver-data #facet-0 .list-unstyled li a:contains("19")').parent().parent().hide();
// remove all items containing 'Past year'
$('.funnelback__ncver-data #facet-1 .list-unstyled li a:contains("Past")').parent().parent().hide();


// remove all items containing '20'
$('.funnelback__ncver-avetmiss #facet-0 .list-unstyled li a:contains("20")').parent().parent().hide();
$('.funnelback__ncver-avetmiss #facet-0 .list-unstyled li a:contains("19")').parent().parent().hide();
// remove all items containing 'Past year'
$('.funnelback__ncver-avetmiss #facet-1 .list-unstyled li a:contains("Past")').parent().parent().hide();


// remove all items containing '20'
$('.funnelback__ncver-news-and-events #facet-0 .list-unstyled li a:contains("20")').parent().parent().hide();
$('.funnelback__ncver-news-and-events #facet-0 .list-unstyled li a:contains("19")').parent().parent().hide();
// remove all items containing 'Past year'
$('.funnelback__ncver-news-and-events #facet-1 .list-unstyled li a:contains("Past")').parent().parent().hide();


// remove all items containing '20'
$('.funnelback__ncver-support #facet-1 .list-unstyled li a:contains("20")').parent().parent().hide();
$('.funnelback__ncver-support #facet-1 .list-unstyled li a:contains("19")').parent().parent().hide();
// rename items
$('.funnelback__ncver-support #facet-1 .list-unstyled li a:contains("Past 6 months")').text("In the past 6 months");
// remove all items containing 'Past year'
$('.funnelback__ncver-support #facet-2 .list-unstyled li a:contains("Past")').parent().parent().hide();


// remove all items containing '20'
$('.funnelback__ncver-infographics #facet-0 .list-unstyled li a:contains("20")').parent().parent().hide();
$('.funnelback__ncver-infographics #facet-0 .list-unstyled li a:contains("19")').parent().parent().hide();
// remove all items containing 'Past year'
$('.funnelback__ncver-infographics #facet-1 .list-unstyled li a:contains("Past")').parent().parent().hide();


// remove all items containing '20'
$('.funnelback__ncver-faq #facet-0 .list-unstyled li a:contains("20")').parent().parent().hide();
$('.funnelback__ncver-faq #facet-0 .list-unstyled li a:contains("19")').parent().parent().hide();
// remove all items containing 'Past year'
$('.funnelback__ncver-faq #facet-1 .list-unstyled li a:contains("Past")').parent().parent().hide();


// Change facet date text across all collection templates
$('.search-results__container .list-unstyled li a:contains("Past 3 months")').text("In the past quarter");
$('.search-results__container .list-unstyled li a:contains("Past 6 months")').text("In the past 6 months");
$('.search-results__container .list-unstyled li a:contains("Past month")').text("In the past month");
$('.search-results__container .list-unstyled li a:contains("Past year")').text("In the past year");
$('.search-results__container .list-unstyled li a:contains("Past fortnight")').text("In the past fortnight");
$('.search-results__container .list-unstyled li a:contains("Past week")').text("In the past week");
// Remove 'Yesterday' from facets across all collection templates
$('.search-results__container .list-unstyled li a:contains("Yesterday")').parent().parent().hide();



$('#search-result-count strong, #search-spelling em a').text(function (i, t) {
    return t.replace('|z:true', '');
});
if ($('#search-result-count strong:first').html() == "" && $('.page-header__heading').length > 0) {
    $('#search-result-count strong:first').html($('.page-header__heading').html().toLowerCase());
}
if ($('#search-result-count strong:first').html() == "" && $('.page-header__heading').length == 0) {
    $('#search-result-count strong:first').html("all");
}
$('input[id^="query-advanced"]').each(function () {
    $(this).val($(this).val().replace(' |z:true', ''));
});

$('#search-result-count strong, #search-spelling em a, #search-spelling em a span').text(function (i, t) {
    return t.replace('a:', '');
});
$('#search-result-count strong, #search-spelling em a, #search-spelling em a span').text(function (i, t) {
    return t.replace('b:', '');
});
$('#search-result-count strong, #search-spelling em a, #search-spelling em a span').text(function (i, t) {
    return t.replace('o:', '');
});
$('#search-result-count strong, #search-spelling em a, #search-spelling em a span').text(function (i, t) {
    return t.replace('q:', '');
});
$('#search-result-count strong, #search-spelling em a, #search-spelling em a span').text(function (i, t) {
    return t.replace('r:', '');
});
$('#search-result-count strong, #search-spelling em a, #search-spelling em a span').text(function (i, t) {
    return t.replace('Z:', '');
});
$('#search-result-count strong, #search-spelling em a, #search-spelling em a span').text(function (i, t) {
    return t.replace(' |z:true', '');
});
$('#search-result-count strong, #search-spelling em a, #search-spelling em a span').text(function (i, t) {
    return t.replace(' a:', '');
});
$('#search-result-count strong, #search-spelling em a, #search-spelling em a span').text(function (i, t) {
    return t.replace(' b:', '');
});
$('#search-result-count strong, #search-spelling em a, #search-spelling em a span').text(function (i, t) {
    return t.replace(' o:', '');
});
$('#search-result-count strong, #search-spelling em a, #search-spelling em a span').text(function (i, t) {
    return t.replace(' q:', '');
});
$('#search-result-count strong, #search-spelling em a, #search-spelling em a span').text(function (i, t) {
    return t.replace(' r:', '');
});
$('#search-result-count strong, #search-spelling em a, #search-spelling em a span').text(function (i, t) {
    return t.replace(' Z:', '');
});

// Results for, replace with page heading
var pageHeading = $('.page-header__heading').text();
$('#search-result-count strong').text(function (i, t) {
    return t.replace('!null', pageHeading);
});



/* ===============================================================================================================================================
 Show more/less on h3 4.18 paint-layout - multipart_content_page
=============================================================================================================================================== */
$(function () {

    $('.multipart_content_page h3').each(function () {
        if (!$(this).next().is("div")) {
            $(this).nextUntil('h3').wrapAll('<div></div>');
        }

        var element = $(this).next("div"),
            elLeng = element.text().length,
            fullHtml = element.html();


        if (elLeng > 190) {
            var cutsWords = trimWords(element.text(), 45);

            element.before('<div class="showed_more" style="display:none"></div>');
            var fullTextContainer = $(this).next('.showed_more');

            fullTextContainer.html('').html(fullHtml);
            element.html('');
            element.addClass('showed_less').html('<p>' + cutsWords + '</p>');
            element.after('<div class="show_hide_wrapper"><button class="show_more_button">Show more</button><button class="show_less_button" style="display:none;">Show less</button></div>');
            $(this).nextUntil('h3').wrapAll('<div class="wrapp_all_after_h3"></div>');
        }
    });
    $('.multipart_content_page h2').each(function () {
        $(this).nextUntil('h2').wrapAll('<div class="wrapp_all_after_h2"></div>');
    });
    $('.multipart_content_page').on('click', 'button.show_more_button', function (event) {
        var parentAll = $(this).parents('.wrapp_all_after_h3');

        parentAll.children('.showed_less').hide();
        parentAll.children('.showed_more').show();

        $(this).hide();
        $(this).siblings('.show_less_button').show();
        Waypoint.refreshAll();
    });
    $('.multipart_content_page').on('click', 'button.show_less_button', function (event) {
        var parentAll = $(this).parents('.wrapp_all_after_h2'),
            topPositionParentAll = parseInt(parentAll.offset().top),
            parrentContent = $(this).parents('.wrapp_all_after_h3');

        parrentContent.children('.showed_more').hide();
        parrentContent.children('.showed_less').show();
        $(this).hide();
        $(this).siblings('.show_more_button').show();
        Waypoint.refreshAll();
        $('html, body').animate({
            scrollTop: topPositionParentAll - 150
        }, 300);
    });

});

function trimWords(theString, numWords) {
    var expString = theString.split(/\s+/, numWords),
        theNewString = expString.join(" ") + ' ...';
    return theNewString;
}



/* ===============================================================================================================================================
    Hide FB Search Pagination when there are less than 20 results
=============================================================================================================================================== */
if ($('.search-pagination li + li').length === 0) {
    $('.search-pagination').hide();
}

/* menu on click */
$('.mobile .accordion__nav-link').on('click', function () {
    $(this).parent().siblings('div').toggleClass('subNavOpened');
    Waypoint.refreshAll();
});

/* ===============================================================================================================================================
    Remove pagination if results only 1 page
=============================================================================================================================================== */

function removePaginationSinglePage() {
    if ($('.search-pagination').length) {
        var $paginationDom = $('.search-pagination');
        var onePage = $paginationDom.find('li').html().indexOf('1 of 1') >= 0;
        if (onePage) {
            $paginationDom.addClass('hidden');
        }
    }
}
removePaginationSinglePage();

/* ===============================================================================================================================================
    Make all tables responsive
=============================================================================================================================================== */
// tables
$(function () {
    $('table').each(function () {
        if ($(this).parent().hasClass('responsiveTables') === false) {
            $(this).wrap('<div class="responsiveTables"></div>');
        }
    });
    $('footer').each(function () {
        if (!$(this).hasClass('footer')) {
            $(this).remove();
        }
    });

    $('#remoteContent a').each(function () {
        if ($(this).attr('href') === 'http://data.ncver.edu.au/resources/vsi.html') {
            $(this).remove();
        }
    });
});


/* ===============================================================================================================================================
    Add Google Anlytics Event Tracking Code to matching links
=============================================================================================================================================== */
// FILES
$('a[href*=".doc"],a[href*=".docx"],a[href*=".pdf"],a[href*=".xls"],a[href*=".xlsx"],a[href*=".mp3"],a[href*=".txt"]').each(function () {
    var linkUrl = $(this).attr("href");
    var fileName = (linkUrl.substr(linkUrl.lastIndexOf('/') + 1));
    $(this).attr("onclick", "ga('send', 'event', 'Document', 'Download', '" + fileName + "');");
});

// MODAL
$('#modal a.close-groups').each(function () { // for each href in the #modal div
    var modalUserType = $(this).attr('data-custom'); // create VAR based on data-custom ATTR value
    $(this).attr("onclick", "ga('send', 'event', 'User Type', 'Selected', '" + modalUserType + "');"); // add onclick event
});

/* ===============================================================================================================================================
    TEMP Manual Order Authors
=============================================================================================================================================== */
$("#content_container_47989 .page-header__authors").each(function () {
    if ($(this).text() === "By Josie Misko, Patrick Korbel") {
        $(this).text("By Patrick Korbel, Josie Misko")
    }
});

